import { render, staticRenderFns } from "./AlarmSettingsPage.vue?vue&type=template&id=6ec30e2d&scoped=true"
import script from "./AlarmSettingsPage.vue?vue&type=script&lang=js"
export * from "./AlarmSettingsPage.vue?vue&type=script&lang=js"
import style0 from "./AlarmSettingsPage.vue?vue&type=style&index=0&id=6ec30e2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec30e2d",
  null
  
)

export default component.exports